export default {
    previousPage:'上一页',
    confirm:'确认',
    sensorCheck:'传感器检查',
    batteryType:'电池类型',
    smartBattery:'智能电池',
    nonIntelligentBattery:'非智能电池',
    battery:'电池',
    power:'电量',
    voltage:'电压',
    temperature:'温度',
    parachute:'降落伞',
    parachuteStatus:'降落伞自检状态',
    selfTestFailed:'自检未通过',
    selfCheckPassed:'自检通过',
    parachutingState:'开伞状态',
    locked:'已锁定',
    unlocked:'已解锁',
    umbrellaOpened:'已开伞',
    compass:'指南针',
    range:'范围',
    accelerometer:'加速度计',
    satellite:'卫星',
    positioningAccuracy:'定位精度',
    positioningType:'定位类型',
    positioning:'定位',
    noPositioning:'无定位',
    poorPositioning:'定位差',
    singlePointPositioning:'单点解定位',
    differentialPositioning:'差分解定位',
    floatingPointRelocation:'浮点解定位',
    fixedUnposition:'固定解定位',
    radar:'雷达',
    front:'前',
    after:'后',
    lower:'下',
    left:'左',
    right:'右',
    structuralInspection:'结构检查',
    input:'输入',
    structuralInspection1:'检查机头实际指向与罗盘方向是否一致',
    structuralInspection2:'检查各个螺旋桨安装方向是否正确',
    structuralInspection3:'检查各个电机转向及安装角度是否正确',
    structuralInspection4:'检查电池安装是否牢固',
    structuralInspection5:'检查机身和机臂连接是否紧固无松脱',
    structuralInspection6:'检查各天线安装是否紧固无松脱',
    structuralInspection7:'检查起落架安装是否牢固',
    structuralInspection8:'检查降落伞是否安装',
    communicationCheck:'通信检查',
    dataLink:'数据链',
    dataLink1:'表示无人机使用T15通信模块与服务器的连接状态',
    dataLink2:'表示无人机使用外接通信模块与服务器的连接状态',
    notConnected:'未连接',
    connected:'已连接',
    notObtained:'未获取',
    mobileNetwork:'移动网络',
    mobileNetwork1:'由于物联网卡的区域限制，新疆、西藏、云南、广西等部分地区可能存在飞行器无法上网的情况，可通过更换当地的SIM卡解决该问题。',
    mobileNetwork2:'LTE链路容易受运营商实时网络环境影响，对于网络要求较高的场景建议使用非物联网卡。',
    mobileNetwork3:'RSSI范围在：-50~-70之间，小于该数值时表示网络信号较差。',
    surplus:'剩余',
    remoteControl:'遥控器',
    externalHandle:'外置手柄',
    configurationCheck:'配置检查',
    flightMode:'飞行模式',
    flightMode1:'未飞行',
    flightMode2:'起飞模式',
    flightMode3:'降落模式',
    flightMode4:'返航模式',
    flightMode5:'原路返航模式',
    flightMode6:'归航模式',
    flightMode7:'指点模式',
    flightMode8:'环绕模式',
    flightMode9:'姿态模式',
    flightMode10:'定高模式',
    flightMode11:'定点模式',
    flightMode12:'自动航线',
    flightMode13:'AB点模式',
    remoteControlHandType:'遥控器手型',
    americanHand:'美国手',
    japaneseHand:'日本手',
    chineseHands:'中国手',
    remoteControlHight:'遥控器高度限制',
    rcProtect:'遥控器失控保护',
    noAction:'无动作',
    hover:'悬停',
    straightReturn:'直线返航',
    directReturn:'直接返航',
    linkRunawayProtection:'链路失控保护',
    RTKtakeoff:'允许无RTK起飞',
    notAllow:'不允许',
    allow:'允许',
    returnAltitude:'返航高度',
    returnSpeed:'返航速度',
    returnDirection:'返航方向',
    headOrientation:'机头朝向',
    tailOrientation:'机尾朝向',
    lowPowerProtection:'低电量保护',
    level1Alarm:'一级报警',
    level2Alarm:'二级报警',
    acoustoOpticAlerting:'声光告警',
    beelineReturn:'直线返航',
    originalReturn:'原路返航',
    land:'降落',
    parachuteDetection:'降落伞检测',
    close:'关闭',
    open:'打开',
    loadCheck:'载荷检查',
    FPVimage:'FPV图像',
    PTZpod:'云台吊舱',
    pager:'喊话器',
    loudspeakerInspection:'喊话器检查',
    thrower:'抛放器',
    pitchControl:'俯仰控制',
    courseControl:'航向控制',
    zoomControl:'缩放控制',
    photoControl:'拍照控制',
    startRecording:'开始录像',
    endRecording:'结束录像',
    imageSwitching:'图像切换',
    targetSolution:'目标解算',
    zuo:'左',
    you:'右',
    whole:'全部',
    danguang:'可见光（单光）',
    shuangguang:'可见光+红外（双光）',
    sanguang:'可见光+红外+激光（三光）',
    notInstalled:'未安装',
    alreadyInstalled:'已安装',
    pleaseSelect:'请选择',
    airspaceInspection:'空域检查',
    airspaceInspection1:'飞行任务是否报备',
    airspaceInspection2:'空域申请是否通过',
    airspaceInspection3:'无人机起飞位置或航线是否穿越禁飞区',
    airspaceInspection4:'无人机起飞位置或航线是否穿越限飞区',
    airspaceInspection5:'无人机起飞位置或航线是否穿越人口密集区',
    tip1:'禁飞区 ：飞行器在任何情况下均不可起飞或飞入该区域。',
    tip2:'禁飞区是以民航局公布的民用机场障碍物限制面及容差缓冲区的12个坐标点为边界点，依次连接后形成的无限高度的封闭坐标区域，该区域内的飞行器不允许解锁和起飞，区域外的飞行器飞行至边界后，强制停止飞行，并自动降落，向设备拥有者及后台发送告警信息。',
    tip3:'限飞区：飞行器可以起飞或进入但飞行高度受限区域。',
    tip4:'限飞区是以跑道正中点为圆心、半径25公里作圆，该圆形范围与禁飞区、非相交的部分，限制高度为50米。',
    tip5:'人口稠密区，是指城镇、村庄、繁忙道路或大型露天集会场所等区域。',
    tip6:'该区域中人员数量较多且集中，该区域飞行存在较大隐患请谨慎操作。',
    yes:'是',
    no:'否',
    inspectionOverview:'检查总览',
    signOut:'退出',
    save:'保存',
    savingSucceeded:'保存成功',
    time:'时段',
    times:'时间',
    inspectors:'检查人员',
    phone:'手机',
    inspectionTime:'检查时间',
    details:'详情',
    chinaTelecom:'中国电信',
    chinaMobile:'中国移动',
    chinaUnicom:'中国联通',
    parachuteStatu:'降落伞状态',
    camera:'FPV摄像头',
    exportPicture:'导出图片',
    inspectionRecord:'检查记录',
    tip_PCTR: '请检查遥控器端配置',
}